export default {
    namespaced: true,
    state: () => ({
        modules: null,
        current: {},
    }),
    getters: {
        modules: ({ modules }) => modules,
        current: ({ current }) => current,
    },
    mutations: {
        setModules(state, modules) {
            state.modules = modules;
        },
        setCurrent(state, current) {
            state.current = current;
        }
    }
}
